export const SIGN_IN_PATH = '/signin';
export const SIGN_IN_MAGIC_LINK_SUCCESS_PATH = '/signin/success';
export const SIGN_UP_PATH = '/signup';
export const HOME_PATH = '/';
export const MOBILE_AUTH_PATH = '/auth';
export const REQUEST_PASSWORD_RESET_PATH = '/forgot-password';
export const RESET_PASSWORD_PATH = '/reset-password';
